<template>
  <div class="search_user" @keyup.enter="searchUser">
    <p class="title">
      <span>{{ !fuzzyName ? "缴费户号" : "用户姓名" }}</span>
      <el-popover
        placement="top-start"
        title="如何查户号"
        width="200"
        trigger="click"
        content="您可以查看缴费账单，催费短信，或拨打客服电话查询。"
      >
        <el-button v-if="!fuzzyName" type="text" slot="reference">如何查户号？</el-button>
      </el-popover>
    </p>
    <div class="bindCode">
      <span class="search_content">
        <input
          type="text"
          class="search_input"
          v-model.trim="yhbm"
          :placeholder="!fuzzyName ? '请输入户号' : '请输入姓名'"
        />
      </span>
    </div>

    <!-- <p v-if="fuzzyName" class="bindName" @click="changeType">
      通过{{ typeFlag ? "姓名" : "户号" }}绑定
    </p> -->
    <p @click="goPage" style="text-align: left;padding-left: 3%;margin-top: 10px">
      <span class="greyText">不知道户号?</span>
      <span class="buleText">更多绑卡方式</span>
    </p>
    <button @click="searchUser" class="btn_bind">
      确 认 {{ !fuzzyName ? " 户 号" : "姓 名" }}
    </button>

  </div>
</template>

<script>
import { getUser, getIfByName, getName,getOpenId } from "@/api";
import { getQueryVariable } from "@/utils";

export default {
  data() {
    return {
      yhbm: "",
      companyCode: sessionStorage.getItem("companyCode"),
      typeFlag: true,
      fuzzyName: false,
    };
  },
  methods: {
    searchUser() {
      if (!this.fuzzyName) {
        if (this.yhbm) {
          getUser({
            companyCode: sessionStorage.getItem("companyCode"),
            code: this.yhbm,
          }).then((res) => {
            if (res) {
              this.$router.push({
                path: "/customer",
                query: res.data,
              });
            }
          });
        } else {
          this.$toast("请输入用户卡号  ");
        }
      } else {
        if (this.yhbm.length < 2) {
          this.$toast("请输入至少两位");
        } else {
          getName({
            name: this.yhbm,
            companyCode: sessionStorage.getItem("companyCode"),
          }).then((res) => {
            if (res && res.data.length) {
              this.$router.push({
                path: "/userNameList",
                query: { name: this.yhbm },
              });
            } else {
              this.$toast("暂无信息，请检查后再次查询");
            }
          });
        }
      }
    },
    goPage() {
      this.$router.push('/moreBind')
    },
    tips() {},
    changeType() {
      this.typeFlag = !this.typeFlag;
    },
  },
  mounted() {
    if(this.companyCode) {
        // getIfByName({ companyCode: this.companyCode }).then((res) => {
        //   this.fuzzyName = res.data.fuzzyName;
        // });
    } else {
      sessionStorage.setItem('ifUse', '1')
      var companyCode = getQueryVariable("state");
      var code = getQueryVariable("code");
      if (companyCode.indexOf("#") > -1) {
        companyCode = companyCode.split("#")[0];
      }
      sessionStorage.setItem("state", companyCode);
      sessionStorage.setItem("companyCode", companyCode);
      getOpenId({
        state: companyCode,
        code: code,
      }).then((res) => {
        var openId = res.data.openId;
        sessionStorage.setItem("thirdId", openId);
        sessionStorage.setItem("unionId", res.data.unionid);
         getIfByName({ companyCode: companyCode }).then((res) => {
          this.fuzzyName = res.data.fuzzyName;
        });
      });
    }

  },

};
</script>

<style scoped>
.search_user {
  background: #fff;
  text-align: center;
  /* padding: 100px 0; */
  min-height: 90%;
  padding-top: 4%;
  /* height: 200px;
    line-height: 200px; */
}
.buleText{
  color: #1E88C7;
  font-size: 12px;
}
.greyText{
  color: #8c939d;
  margin-right: 10px;
  font-size: 12px;
}
.title {
  width: 94%;
  display: flex;
  padding: 0 3%;
  font-size: 16px;
  justify-content: space-between;
}
.model_code {
  font-size: 12px;
  color: cornflowerblue;
}
.bindCode {
  margin-top: 2rem;
}
.icon_user {
  font-size: 25px;
  color: #26a2ff;
}
.search_input {
  border: none;
  outline: none;
  height: 35px;
  line-height: 35px;
  font-size: 20px;
  width: 100%;
  /* margin: 1px 10px; */
  /* border-bottom: 1px solid #999999; */
}
.search_content {
  display: inline-block;
  width: 94%;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #999999;
}
.icon_search {
  font-size: 22px;
  color: #999;
}
.listUsers {
  background: #fff;
}
.bindName {
  text-align: right;
  padding: 10px 3%;
  color: cornflowerblue;
}
</style>




// WEBPACK FOOTER //
// src/view/yhBind/searchUser.vue